import { determineCommModal } from 'ui-addon-upgrades/_core/contactSales/utils';
import { AssignableModal } from '../communicationMethods/AssignableModal';
import { RetailModal } from '../communicationMethods/RetailModal';
import UnassignableModal from '../communicationMethods/UnassignableModal';
import MeetingModal from '../communicationMethods/MeetingModal';
import { COMM_METHODS_MODAL_TYPES } from './constants';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { submitPql } from '../pql/submitPql';
import { trackTalkToSalesPql } from '../utils/metricUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CommModalContainer = ({
  handleClose,
  isFreePortal,
  isRetailPortal,
  isAssignable,
  modalRoot,
  upgradeData,
  repInfo,
  _overrideCommunicationMethodKey,
  _overrideModalHeaderText,
  isUpgradePoint,
  _shouldBypassCommsModal
}) => {
  const commMethodsModalType = determineCommModal({
    repInfo,
    isRetailPortal,
    isAssignable
  });
  if (_shouldBypassCommsModal) {
    void submitPql(Object.assign({}, upgradeData, {
      isRetail: isRetailPortal,
      isAssignable,
      repInfo
    }));
    trackTalkToSalesPql(upgradeData.app);
    if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.UNASSIGNABLE) {
      loadAndOpenSalesChat({
        upgradeData,
        isRetail: isRetailPortal
      });
      return null;
    }
    if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.ASSIGNABLE) {
      return /*#__PURE__*/_jsx(MeetingModal, {
        modalRoot: modalRoot,
        upgradeData: upgradeData,
        onClose: handleClose,
        isUpgradePoint: isUpgradePoint,
        repInfo: repInfo
      });
    }
    return null;
  }
  if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.UNASSIGNABLE) {
    if (isRetailPortal) {
      return /*#__PURE__*/_jsx(RetailModal, {
        modalRoot: modalRoot,
        upgradeData: upgradeData,
        onClose: handleClose,
        isUpgradePoint: isUpgradePoint
      });
    }
    return /*#__PURE__*/_jsx(UnassignableModal, {
      modalRoot: modalRoot,
      upgradeData: upgradeData,
      onClose: handleClose,
      isUpgradePoint: isUpgradePoint
    });
  }
  if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.ASSIGNABLE) {
    return /*#__PURE__*/_jsx(AssignableModal, {
      modalRoot: modalRoot,
      _overrideCommunicationMethodKey: _overrideCommunicationMethodKey,
      _overrideModalHeaderText: _overrideModalHeaderText,
      upgradeData: upgradeData,
      onClose: handleClose,
      isFreePortal: Boolean(isFreePortal),
      isUpgradePoint: isUpgradePoint,
      repInfo: repInfo,
      handleIframeSizeChange: () => {}
    });
  }
  return null;
};
export default CommModalContainer;